import PasswordFieldBase from '../inputs/PasswordInput';
import createField from './createField';

const PasswordField = createField(PasswordFieldBase);

export default PasswordField;
